import {Component} from '@angular/core';
import {IBaseComponent} from '../../../../sdk/src/components/ibase/ibase.component';

/**
 * Footer component
 */
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent extends IBaseComponent {
    /**
     * On ready (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onReady(): Promise<void> {}
    /**
     * On destroy (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onDestroy(): Promise<void> {}
}
